export default __webpack_public_path__ + "static/media/hierros.7925d2af.png";